<template>
  <div class="company-msg" v-if="funcView.base_info">
    <factory v-if="bizType === 'HQ'" :propsFuncView="funcView"></factory>
    <group-customer v-else-if="bizType === 'CO'" :propsFuncView="funcView"></group-customer>
    <renter v-else-if="bizType === 'CS'" :propsFuncView="funcView"></renter>
    <service-company v-else :propsFuncView="funcView"></service-company>
  </div>
</template>

<script>
import serviceCompany from '@/pages/crm/serviceCompany/children/company_detail.vue';
import factory from '@/pages/crm/factory/children/factory_detail.vue';
import groupCustomer from '@/pages/crm/groupCustomer/children/groupCustomer_detail.vue';
import renter from '@/pages/crm/renter/children/renter_detail.vue';

export default {
  name: 'companyMsg',
  components: {
    serviceCompany,
    factory,
    groupCustomer,
    renter
  },
  computed: {
    bizType() {
      return this.$store.state.userInfo.bizType;
    }
  },
  mounted() {
    this.getFuncView('/companyInfo/msg');

  }
};
</script>

<style>
.company-msg{
  height: 100%;
}
</style>
